import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthContext.js";
import { Layout } from "./components/Layout.js";
import { LoginPage } from "./pages/LoginPage.js";
import { RegisterPage } from "./pages/RegisterPage.js";
import { VerifyEmailPage } from "./pages/VerifyEmailPage.js";
import { DashboardPage } from "./pages/DashboardPage.js";
import { PropertiesPage, PropertyDetailPage, PropertyFormPage } from "./pages/PropertiesPage.js";
import { FinancePage } from "./pages/FinancePage.js";
import { TaxPage } from "./pages/TaxPage.js";
import { InsightsPage } from "./pages/InsightsPage.js";
import { BillingPage } from "./pages/BillingPage.js";
import { IntegrationsPage } from "./pages/IntegrationsPage.js";
import { SettingsPage } from "./pages/SettingsPage.js";

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading"><span className="spinner-ring" />Loading your workspace…</div>;
  if (!user) return <Navigate to="/login?reason=session" replace />;
  return <>{children}</>;
}

function PublicOnly({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading"><span className="spinner-ring" />Preparing Nettstay…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Protected><Layout><DashboardPage /></Layout></Protected>} />
          <Route path="/properties" element={<Protected><Layout><PropertiesPage /></Layout></Protected>} />
          <Route path="/properties/new" element={<Protected><Layout><PropertyFormPage mode="create" /></Layout></Protected>} />
          <Route path="/properties/:id" element={<Protected><Layout><PropertyDetailPage /></Layout></Protected>} />
          <Route path="/properties/:id/edit" element={<Protected><Layout><PropertyFormPage mode="edit" /></Layout></Protected>} />
          <Route path="/finance" element={<Protected><Layout><FinancePage /></Layout></Protected>} />
          <Route path="/tax" element={<Protected><Layout><TaxPage /></Layout></Protected>} />
          <Route path="/insights" element={<Protected><Layout><InsightsPage /></Layout></Protected>} />
          <Route path="/billing" element={<Protected><Layout><BillingPage /></Layout></Protected>} />
          <Route path="/integrations" element={<Protected><Layout><IntegrationsPage /></Layout></Protected>} />
          <Route path="/settings" element={<Protected><Layout><SettingsPage /></Layout></Protected>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
